export enum MemberLevelEnum {
  Customer = 0,
  Manager = 1,
  DeputyHead = 2,
  Head = 3,
  DeputyDirector = 4,
  Director = 5,
}

export const MEMBER_LEVEL_LABELS: Record<MemberLevelEnum, string> = {
  [MemberLevelEnum.Customer]: "KH",
  [MemberLevelEnum.Manager]: "Quản lý",
  [MemberLevelEnum.DeputyHead]: "Phó phòng",
  [MemberLevelEnum.Head]: "Trưởng phòng",
  [MemberLevelEnum.DeputyDirector]: "Phó giám đốc",
  [MemberLevelEnum.Director]: "Giám đốc",
};

export const MEMBER_LEVEL_OPTIONS = Object.values(MemberLevelEnum)
  .filter((value) => typeof value === "number")
  .map((value) => ({
    label: MEMBER_LEVEL_LABELS[value as MemberLevelEnum],
    value: value as MemberLevelEnum,
  }));

export const getMemberLevelLabel = (value?: number | null) => {
  if (value == null) return "-";
  return MEMBER_LEVEL_LABELS[value as MemberLevelEnum] ?? `${value}`;
};
